<template>
    <section class="fleet-setup-favorites-setup mb-2">
        <div class="team-added-card">
            <div class="team-added-header">
                <div class="complete-icon"><icon name="faCheck" type="solid"></icon></div>

                <div>
                    <h2 class="my-0 td-h4">Add Favorite Networks</h2>
                    <p v-if="savedNetworks.length > 0" class="td-text-success td-text-mice mt-1 mb-0">Dealer Networks Selected</p>
                </div>
            </div>

            <p class="mt-1 mb-0">
                You can manage your favorite and avoided vendors later in your <a href="/admin" title="Admin" class="td-link">account settings</a>.  In your search results, you can also add individual vendors to your favorite or avoid list.
            </p>

            <ul class="td-list my-2 networks-list">
                <li class="list-item my-1" v-for="network in savedNetworks" :key="network.code">
                    <icon name="faCircleCheck" type="solid" class="td-text-primary-dark"></icon>
                    <p>{{network.name}}</p>
                </li>
            </ul>

            <div class="team-actions">
                <button class="td-btn primary icon-left" @click="openDealersModal" title="Add Dealer Network" :disabled="isLoading">
                    <icon name="faPlus" type="solid"></icon>
                    <span v-if="savedNetworks.length > 0"> Edit List </span>
                    <span v-if="savedNetworks.length == 0"> Add Networks </span>
                </button>
            </div>
        </div>
        <modal @close="closeDealersModal" style="height:max-content;" v-if="showDealersModal" class="edit-modal" hideFooter>
            <div class="td-edit-container one-step services-modal">
                <div class="pagination">
                    <div class="form-name mb-4">
                        <h3 style="border:none;"> Select Favorite Networks</h3>
                    </div>
                    <div class="step-description">
                        <div class="step active">
                            <p>
                                Select favorite networks to include verified vendors in your search.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="edit-pages">
                    <div class="form-page active td-form wide-form">
                        <div class="td-banner danger dismissible my-2" v-if="errorMessage">
                            <icon name="faCircleExclamation" type="solid"></icon>
                            <p>{{ errorMessage }}</p>
                            <icon name="faXmark" type="solid" @click="errorMessage = undefined"></icon>
                        </div>
                        <div class="td-flex" id="networks-heading">
                            <h4>Tire & Authorized Repair Networks</h4>
                            <button class="td-btn mb-2 danger slim" title="Clear networks selection" @click.prevent="clearNetworks">Clear All</button>
                        </div>
                        <div class="inputs-column service-list">
                            <template v-for="network in networks" :key="network.code">
                                <div :class="[isSelectedNetwork(network) ? 'selected' : '', 'rounded', 'service-select', 'td-card', 'grey']"
                                     @click="handleNetworkSelect(network)">
                                    <icon v-if="isSelectedNetwork(network)" name="faCheck" type="solid" class="mx-1"></icon>
                                    <icon v-if="!isSelectedNetwork(network)" name="faSquare" type="regular" class="mx-1"></icon>
                                    <span>{{network.name}}</span>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="actions">
                        <div>
                            <button class="td-btn btn secondary-outlined" title="Cancel Networks Selection" @click="closeDealersModal">Cancel</button>
                        </div>
                        <div class="save-btn">
                            <button class="secondary td-btn" title="Select Dealer Networks" @click="handleNetworksSave" :disbled="isLoading">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </section>
</template>

<script>
import script from './FavoritesSetup';
    export default script;</script>

<style lang="less">
    @import "./FavoritesSetup.less";
</style>